module.exports = __webpack_public_path__ + "static/element_404-e887ab9476717f4eeef3eee9d2ea06c8.svg";